import { HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { forkJoin, Observable } from 'rxjs'
import { ProjectorsEntity, ReorderProjectorSlidesPayload } from './projectors.models'
import { ProjectorTemplatesEntity } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.models'

@Injectable({
  providedIn: 'root',
})
export class ProjectorsApiService extends GbApiService {
  getProjectors(urlName: string): Observable<ProjectorsEntity[]> {
    return this.get<ProjectorsEntity[]>(`auctions/${urlName}/projectors/`)
  }

  createProjector(name: string, urlName: string, templateUuid: string): Observable<ProjectorsEntity> {
    let projector: { name: string; auction: string; template_uuid?: string } = { name, auction: urlName }
    if (templateUuid) projector = { ...projector, template_uuid: templateUuid }
    const url = `auctions/${urlName}/projectors/`
    return this.post<ProjectorsEntity>(url, projector)
  }

  createSlide(
    name: string,
    urlName: string,
    containerUuid: string,
    templateUuid?: string,
  ): Observable<ProjectorsEntity> {
    const projector: { name: string; auction: string; container: string; template_uuid?: string } = {
      name,
      auction: urlName,
      container: containerUuid,
    }

    if (templateUuid) {
      projector.template_uuid = templateUuid
    }

    const url = `auctions/${urlName}/projectors/`
    return this.post<ProjectorsEntity>(url, projector)
  }

  updateProjector(projector: Partial<ProjectorsEntity>, urlName: string): Observable<ProjectorsEntity> {
    projector = { ...projector, auction: urlName }
    const url = `auctions/${urlName}/projectors/${projector.uuid}/`
    return this.patch<ProjectorsEntity>(url, projector)
  }

  reorderSlides(urlName: string, slides: ReorderProjectorSlidesPayload[]): Observable<ProjectorsEntity[]> {
    const apiCalls = slides.map((slide) => this.updateProjector(slide, urlName))
    return forkJoin(apiCalls)
  }

  deleteProjector(uuid: string, urlName: string): Observable<void> {
    const url = `auctions/${urlName}/projectors/${uuid}/`
    return this.delete<void>(url)
  }

  getPresenterEditToken() {
    const baseApiUrl = this.appConfig.baseApiUrl
    const url = `${baseApiUrl}otu-token/generate_presenter_token/`
    return this.http.get<{ otu_token: string }>(url, {
      withCredentials: true,
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache',
      }),
    })
  }

  getProjectorTemplates(): Observable<ProjectorTemplatesEntity[]> {
    const url = 'projector-templates/'
    return this.get<ProjectorTemplatesEntity[]>(url)
  }

  deleteProjectorTemplate(templateUuid: string): Observable<void> {
    const url = `projector-templates/${templateUuid}/`
    return this.delete<void>(url)
  }
}
